import Vue from 'vue';
import Router from 'vue-router';
import HomeView from '@/views/home';
import FaqView from '@/views/faq';
import LegalView from '@/views/legal';
import TransportauftragView from '@/views/transportauftrag';
import TippsView from '@/views/tippszumkauf';
import FunktionView from '@/views/wiefunktionierts';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: HomeView
    },
    {
      path: '/#Service',
      name: 'Service',
      component: HomeView
    },
    {
      path: '/#contactkey',
      name: 'Contact',
      component: HomeView
    },
    {
      path: '/faq',
      name: 'FAQ',
      component: FaqView
    },
    {
      path: '/tippszumkauf',
      name: 'Tipps zum Kauf',
      component: TippsView
    },
    {
      path: '/wiefunktionierts',
      name: 'Wie funktionierts',
      component: FunktionView
    },
    {
      path: '/legal',
      name: 'Legal',
      component: LegalView
    },
    {
      path: '/transportauftrag',
      name: 'Transportauftrag',
      component: TransportauftragView
    },
  ],
  scrollBehavior (_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } 
    return { x: 0, y: 0 };
  }
});